<template>
  <card shadow type="secondary" :key="tick+'afdhuisdhf'">
    <div slot="header" class="bg-white border-0">
      <div class="row align-items-center">
        <div class="col-8">
          <h3 class="mb-0">Oasis Dashboard</h3>
          <h6 class="text-uppercase text-muted ls-1 mb-0">Verwalten und prüfen der Verbindungen zu OASIS</h6>
        </div>
        <div class="col-4 text-right">
          <base-button v-if="newDataToSave.length > 0" @click="saveAll" type="success" icon="fas fa-save" size="sm">alle speichern</base-button>
          <base-button @click="checkAll" type="secondary" icon="ni ni-sound-wave" size="sm">alle prüfen</base-button>
        </div>
      </div>
    </div>
    <template>
      <div class="row" v-if="$store.getters['authentication/isOperator']">
        <div class="col">
          <base-button v-if="certCount === 0" @click="$router.push('/oasiscerts/create')" type="success">Kein Zertifikat gefunden - neues OASIS-Zertifikat hinzufügen</base-button>
          <base-button v-else-if="certCount > 0 && (newerCertAvailable || locationCertCount === 0)" @click="setNewestCerts" type="success">Neues Zertifikat gefunden - Bei allen Standorten hinterlegen</base-button>

          <base-dropdown position="left">
            <base-button slot="title" icon="ni ni-fat-add" type="secondary" class="dropdown-toggle">
              Zertifikat auswählen
            </base-button>
            <a v-for="cert in certs" :key="cert.id" class="dropdown-item align-right" href="#" @click="setCerts(cert)">{{ cert.name }} |
              <span v-if="(typeof cert.privateCertValidDates !== 'undefined')">gültig bis: {{cert.privateCertValidDates.to | formatDateToDay }} </span>
              <span v-else>ERROR</span> bei allen Standorten hinterlegen</a>
            <a href="#" @click.prevent="$router.push('/oasiscerts/create')" class="dropdown-item align-right">Neues Zertifikat hochladen</a>
          </base-dropdown>

          <p class="mt-4">
            <span class="text-muted">Die <b>OASIS WS - Betriebsstättenkennungen</b> finden Sie im  <b>OASIS Nutzungsvertrag</b>.</span><br>
            <span class="text-muted">Die <b>OASIS WS - Betriebsstättenpasswörter</b> finden Sie im <b>Passwortbrief</b> vom <b>RP Darmstadt</b>.</span>
          </p>
        </div>
      </div>
          <div class="table-responsive">
          <base-table class="table align-items-center table-flush mt-4"
                      tbody-classes="list"
                      thead-classes="thead-light"
                      :data="locations">
            <template slot="columns">
              <th>Standort</th>
              <th>Zertifikat</th>
              <th>Betriebsstättenkennung</th>
              <th>Betriebsstättenpasswort</th>
              <th></th>
            </template>
            <template slot-scope="{row}">
              <th scope="row"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}</div></th>
              <td scope="row"><div v-if="isLoading" class="loading"> </div><div v-else>
                <select v-model="row.oasiscert"
                        class="mb-0 custom-select form-control form-control-alternative form-control-lg"
                v-on:change="()=> { if(!newDataToSave.includes(row.id)) newDataToSave.push(row.id); }">
                <option :value="null" selected>kein Zertifikat</option>
                <option v-for="cert in certs" :key="cert.id" v-bind:value="cert">{{ cert.name }} |
                  <span v-if="(typeof cert.privateCertValidDates !== 'undefined')">gültig bis: {{cert.privateCertValidDates.to | formatDateToDay }} </span>
                  <span v-else>ERROR</span>
                </option>
              </select></div></td>
              <td scope="row"><div v-if="isLoading" class="loading"> </div><div v-else><base-input v-model="row.oasisid" input-classes="form-control-alternative" class="mb-0" v-on:change="()=> { if(!newDataToSave.includes(row.id)) newDataToSave.push(row.id); tick++; }"></base-input></div></td>
              <td scope="row"><div v-if="isLoading" class="loading"> </div><div v-else><base-button v-if="typeof row.oasispw === 'undefined'" v-on:click="enableChangePW(row)" size="sm">ändern</base-button><base-input v-else v-model="row.oasispw" v-on:change="()=> { if(!newDataToSave.includes(row.id)) newDataToSave.push(row.id); tick++; }" input-classes="form-control" class="mb-0"><template slot="addonRight"><a href="#" v-on:click.prevent="enableChangePW(row)"><i class="text-danger fas fa-ban"></i></a></template> </base-input></div></td>
              <td class="text-right">
                <div v-if="isLoading" class="loading"> </div><div v-else>
                  <base-button v-if="newDataToSave.includes(row.id)" v-on:click="saveLocation(row)" :disabled="savingItems.includes(row.id)" :icon="(savingItems.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-save'" type="primary" size="sm" icon-only
                               title="speichern"></base-button>
                  <base-button v-else :type="(status.checkedSuccess.includes(row.id)) ? 'success' : 'primary'" size="sm" :icon="(status.checkingItems.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'ni ni-sound-wave'" :disabled="savingItems.includes(row.id)" v-on:click="checkOasis(row)" icon-only></base-button>
                  <base-button v-if="typeof status.checkError[row.id] !== 'undefined' " size="sm" type="danger" v-b-tooltip.hover.left :title="status.checkError[row.id]">
                  ERROR
                  </base-button>
                </div>
              </td>
              <!---<th><div v-if="isLoading" class="loading"> </div><div v-else>{{!isExpired(row.invalidAt) ? $options.filters.formatDateFromNow(row.invalidAt) : 'abgelaufen'}}</div></th>--->
            </template>
          </base-table>
          </div>
    </template>
  </card>
</template>

<script>
  export default {
    name:"Oasis",
    data(){
      return {
        locations: [],
        certs: [],
        totalItems: 0,
        isLoading: false,
        savingItems:[],
        status :{
          checkingItems: [],
          checkedSuccess: [],
          checkError: []
        },
        newDataToSave: [],
        tick: 1
      }
    },
    created(){
      this.refreshCerts();
      this.$store.dispatch('location/getLocationCollection').then(data => {this.locations = data['hydra:member']; this.tick++})
    },
    computed: {
      certCount() { return this.certs.length },
      locationCertCount() { return (this.locations.length === 0) ? 0 : this.locationCerts().length },
      newerCertAvailable() { return (this.locations.length !== 0 && this.certs.length !== 0 ) ?  (this.certs.length > 0 && this.locationCerts().length === 0) ? 1 : new Date(this.latestCertExpiredDate()) - new Date(this.latestLocationCertExpiredDate()) : 0 }
    },
    methods: {
      async checkAll() {
        for await (const loc of this.locations) {
          if (!this.newDataToSave.includes(loc.id) && !this.savingItems.includes(loc.id) && !this.status.checkingItems.includes(loc.id)) {
            try {
              await this.checkOasis(loc)
            } catch (e) {
              // eslint-disable-next-line no-console
              console.log(e.toString())
            }
          }
        }
        this.tick++
      },
      saveAll() {
        this.locations.forEach(loc => {
          if (this.newDataToSave.includes(loc.id)) {
            this.saveLocation(loc)
          }
        })
      },
      saveLocation(data) {
        return new Promise(() => {
          this.savingItems.push(data.id);
          const header = this.authHeader();
          header['Content-Type'] = 'application/merge-patch+json';
          let senddata = JSON.parse(JSON.stringify(data));
          if (senddata.oasiscert !== null) {
            senddata.oasiscert = senddata.oasiscert['@id'];
          }
          const requestOptions = {
            method: 'PATCH',
            headers: header,
            body: JSON.stringify(senddata)
          };
          fetch(process.env.VUE_APP_API_SERVER + `/api/locations/`+data.id, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                    this.$store.dispatch('alert/success', 'Standort '+response.name+' (ID: '+response.id+') wurde editiert.');
                    this.savingItems.splice(this.savingItems.indexOf(data.id),1)
                    this.newDataToSave.splice(this.newDataToSave.indexOf(data.id),1)
                    this.tick++
                  },
                  error => {
                    this.savingItems.splice(this.savingItems.indexOf(data.id),1)
                    this.$store.dispatch('alert/error', error);
                    this.tick++
                  });
        });
      },
      setNewestCerts() {
        let newestCert = this.certs.filter(cert => { return typeof cert.privateCertValidDates !== 'undefined'}).sort(function(a,b){
          return new Date(b.privateCertValidDates.to) - new Date(a.privateCertValidDates.to);
        })[0];
        this.locations.forEach(loc => {
          this.newDataToSave.push(loc.id);
          loc.oasiscert = newestCert;
        })
      },
      setCerts(cert) {
        this.locations.forEach(loc => {
          this.newDataToSave.push(loc.id);
          loc.oasiscert = cert;
        })
      },
      enableChangePW(row) {
        if(typeof row.oasispw === 'undefined'){
          Object.assign(row,{oasispw:null});
        } else {
          delete row.oasispw;
        }
        this.tick++;
      },
      latestCertExpiredDate(){
        return this.certs.filter(cert => { return typeof cert.privateCertValidDates !== 'undefined'}).sort(function(a,b){
          return new Date(b.privateCertValidDates.to) - new Date(a.privateCertValidDates.to);
        })[0].privateCertValidDates.to;
      },
      latestLocationCertExpiredDate(){
        return this.locationCerts().filter(loc => { return typeof loc.oasiscert !== 'undefined'}).sort(function(a,b){
          return new Date(b.oasiscert.privateCertValidDates.to) - new Date(a.oasiscert.privateCertValidDates.to);
        })[0].oasiscert.privateCertValidDates.to;
      },
      locationCerts() {
        return Array.from(this.locations).filter(location => {
          return typeof location.oasiscert !== "undefined"
        })
      },
      refreshCerts() {
        this.isLoading = true;
        this.getCertData().then(
            response => {
              this.certs = response.member;
              this.certs.forEach(cert => { cert.customer = cert.customer['@id'] });
              this.totalitems = response.totalItems;
              this.isLoading = false;
            }
        )
      },
      getCertData(){
        return new Promise((resolve, reject) => {
          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header
          };

          fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs?pagination=false`, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                resolve({
                  totalItems: response['hydra:totalItems'],
                  member: response['hydra:member']
                });
              }, error => {reject(error); });
        });
      },
      checkOasis(data) {
        return new Promise((resolve,reject) => {


          this.status.checkingItems.push(data.id);
          if(this.status.checkedSuccess.includes(data.id)) {
            this.status.checkedSuccess.splice(this.status.checkedSuccess.indexOf(data.id),1);
          }
          delete this.status.checkError[data.id];
          this.tick++;

          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header,
          };

          let url = '/oasis/validate/'+data.id;

          fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                    const meldungItem = response['MELDUNGSKATALOG-ITEM'] || response;
                    const schluessel = meldungItem.SCHLUESSEL;
                    const meldung = meldungItem.MELDUNG;

                    if (schluessel === "0049") {
                      this.status.checkedSuccess.push(data.id);
                    } else {
                      this.status.checkError[data.id] = `${schluessel}: ${meldung}`;
                    }

                    resolve(response);},
                  error => {
                    this.status.checkError[data.id]  = error;
                    reject(error);
                    })
              .finally( () => {
                this.status.checkingItems.splice(this.status.checkingItems.indexOf(data.id),1);
                this.tick++;
              });
        });
      },
    }
  }
</script>

<style scoped>

</style>